import React, { Component } from 'react';
/* eslint-disable */
import { Route } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
// import Topbar from '../Apanel/topbar/Topbar';
import TopbarWithNavigation from '../Apanel/topbar_with_navigation/TopbarWithNavigation';
// import Sidebar from '../Apanel/sidebar/Sidebar';
import Dashboard from './components/Dashboard';
import Asettings from './components/Asettings';
import Profile from '../Apanel/index';
import ProfileEdit from '../Apanel/UserProfileEdit';
import ReportsPage from './components/ReportsPage';
import ReportsSevenDaysPage from './components/ReportsSevenDaysPage';

import Rashboard from './components/recruiterpages/Dashboard';
import AddTest from './components/recruiterpages/AddTest';
import FaqTechView from './components/recruiterpages/FaqTechView';
import FaqTechQues from './components/recruiterpages/FaqTechQues';
import SaveTest from './components/recruiterpages/SaveTest';
import CustomSavedTest from './components/recruiterpages/CustomSavedTest';
import CustomSentTests from './components/recruiterpages/CustomSentTests';
import CusComTest from './components/recruiterpages/CusComTest';
import CustomTestReport from './components/recruiterpages/CustomTestReport';
import SentTests from './components/recruiterpages/SentTests';
import ComTest from './components/recruiterpages/ComTest';
import TestReport from '../Apanel/TestReport';
import Emailids from './components/recruiterpages/Emailids';
import Mytickets from './components/recruiterpages/Mytickets';
import Viewticket from './components/recruiterpages/Viewticket';
import Closedt from './components/recruiterpages/Closedt';
import AddQuest from './components/recruiterpages/AddQuest';
import ViewQuest from './components/recruiterpages/ViewQuest';
import Allmycustoms from './components/recruiterpages/Allmycustoms';
import MyQuestions from './components/recruiterpages/MyQuestions';

import TechReportsPage from './components/TechReportsPage';

const initialstate = {
	sidebarShow: false,
	sidebarCollapse: false,
};

class CompanyPanel extends Component {
	constructor(props) {
		super(props);
	}
	state = { ...initialstate };
	componentDidMount() {
		// this.insertTawkto();

		if (localStorage.viewrecruiter) {
			const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			let isvalidrec = re.test(localStorage.viewrecruiter);
			if (isvalidrec) {
				this.props.history.push('/recruiter/dashboard');
			} else {
				this.props.history.push('/dashboard');
			}
		}
	}
	insertTawkto() {
		var Tawk_API = Tawk_API || {},
			Tawk_LoadStart = new Date();
		(function () {
			var s1 = document.createElement('script'),
				s0 = document.getElementsByTagName('script')[0];
			s1.async = true;
			s1.src = 'https://embed.tawk.to/5da35321fbec0f2fe3b98448/default';
			s1.charset = 'UTF-8';
			s1.setAttribute('crossorigin', '*');
			s0.parentNode.insertBefore(s1, s0);
		})();
	}

	changeSidebarVisibility = () => {
		this.setState((prevState) => ({
			sidebarCollapse: !prevState.sidebarCollapse,
		}));
	};

	changeMobileSidebarVisibility = () => {
		this.setState((prevState) => ({ sidebarShow: !prevState.sidebarShow }));
	};

	render() {
		const { sidebarShow, sidebarCollapse } = this.state;
		const layoutClass = classNames({
			layout: true,
			'layout--collapse': sidebarCollapse,
		});

		return (
			<div>
				{/* <div className={layoutClass}> */}
				<div className="layout layout--top-navigation">
					{/* <Topbar
						changeMobileSidebarVisibility={this.changeMobileSidebarVisibility}
						changeSidebarVisibility={this.changeSidebarVisibility}
					/> */}
					<TopbarWithNavigation
						changeMobileSidebarVisibility={this.changeMobileSidebarVisibility}
					/>
					{/* <Sidebar
						sidebarShow={sidebarShow}
						sidebarCollapse={sidebarCollapse}
						changeMobileSidebarVisibility={this.changeMobileSidebarVisibility}
					/> */}
				</div>
				<div className="container__wrap">
					<Route path="/recruiter/dashboard" component={Rashboard} />
					<Route path="/recruiter/emailids" component={Emailids} />
					<Route path="/recruiter/testreport" component={TestReport} />
					<Route path="/recruiter/addtest" component={AddTest} />
					<Route path="/recruiter/faqtechview" component={FaqTechView} />
					<Route path="/recruiter/faqtechsques" component={FaqTechQues} />
					<Route path="/recruiter/savetest" component={SaveTest} />
					<Route
						path="/recruiter/customsavedtest"
						component={CustomSavedTest}
					/>
					<Route path="/recruiter/customsenttest" component={CustomSentTests} />
					<Route path="/recruiter/cuscomtest" component={CusComTest} />
					<Route path="/recruiter/custestreport" component={CustomTestReport} />
					<Route path="/recruiter/senttests" component={SentTests} />
					<Route path="/recruiter/comtest" component={ComTest} />
					<Route path="/recruiter/mytickets" component={Mytickets} />
					<Route path="/recruiter/viewticket" component={Viewticket} />
					<Route path="/recruiter/closedt" component={Closedt} />
					<Route path="/recruiter/addcustomtest" component={AddQuest} />
					<Route path="/recruiter/viewcustomtest" component={ViewQuest} />
					<Route path="/recruiter/mycustoms" component={Allmycustoms} />
					<Route path="/recruiter/myqueslist" component={MyQuestions} />

					<Route path="/dashboard" component={Dashboard} />
					<Route path="/asettings" component={Asettings} />
					<Route path="/profile" component={Profile} />
					<Route path="/profileedit" component={ProfileEdit} />
					<Route path="/reportspage" component={ReportsPage} />
					<Route path="/reportseven" component={ReportsSevenDaysPage} />
					<Route path="/techreportspage" component={TechReportsPage} />
					<Route path="/testreport" component={TestReport} />
				</div>
			</div>
		);
	}
}

export default withRouter(CompanyPanel);
